import React, { Component } from 'react';
import { Grid, Cell, ProgressBar } from 'react-mdl';


class Skills extends Component {
  render() {
    return(
      <Grid>
        <Cell col={12}>
          <div style={{display: 'inline	'}}>{this.props.skill} <ProgressBar animated now={45} style={{ width: '90%'}} progress={this.props.progress} /> </div>
        </Cell>
      </Grid>
    )
  }
}

export default Skills;



// WEBPACK FOOTER //
// ./src/components/skills.js